import React, { useEffect, useState } from 'react';

import { SP_COOKIE_BANNER_EVENTS } from 'Utilities/analytics/analyticsCookieBanner';
import { useIsEmbeddedView } from 'Utilities/hooks/useIsEmbeddedView';

import { CookieBanner } from './CookieBanner';
import { ACCEPT_ALL_CONSENT, COOKIE_POLICY_PATH, ESSENTIALS_ONLY_CONSENT } from './cookieConsent.constants';
import { applyConsent, hasStoredConsent } from './cookieConsent.helpers';

import styles from './CookieConsent.module.scss';

export const CookieConsent = () => {
  const isEmbeddedView = useIsEmbeddedView();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!hasStoredConsent());
  }, []);

  const handleAcceptAll = () => {
    SP_COOKIE_BANNER_EVENTS.ACCEPT_ALL_CLICKED();
    applyConsent(ACCEPT_ALL_CONSENT);
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    SP_COOKIE_BANNER_EVENTS.ESSENTIAL_ONLY_CLICKED();
    applyConsent(ESSENTIALS_ONLY_CONSENT);
    setVisible(false);
  };

  const handleLearnMore = () => {
    SP_COOKIE_BANNER_EVENTS.LEARN_MORE_CLICKED(COOKIE_POLICY_PATH);
  };

  if (!visible || isEmbeddedView) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <CookieBanner
        onAcceptAll={handleAcceptAll}
        onEssentialOnly={handleEssentialOnly}
        onLearnMore={handleLearnMore}
      />
    </div>
  );
};
